import { gql } from '@apollo/client'

export default gql(`
subscription{
    publishRulesUpdated{
        id
        assetId
        group{
          id
        }
        isEnabled
        publishEndDate
        publishStartDate
      }
  }`)
